import { ResponsiveState } from "@core/global-state/responsive/responsive.reducer";
import { createFeatureSelector, createSelector } from "@ngrx/store";


export const selectResponsiveState = createFeatureSelector<ResponsiveState>('responsive');
export const selectCurrentSize = createSelector(selectResponsiveState,(state: ResponsiveState) => state.sizeDevice);